const SkeletonBlog = () => {
  return (
    <li className="flex bg-[#15202B] transition-colors duration-500 ease-in-out p-2 pb-4 border-t-[4px] border-[#314f6c] border-opacity-70 rounded group">
      <div className="flex flex-col w-full space-y-4 items-center">
        <p className="loading bg-[#314f6c] bg-opacity-70 w-40">&#160;</p>
        <div className="loading relative h-40 w-full flex justify-center items-center overflow-hidden bg-[#314f6c] bg-opacity-70 "></div>
        <span className="loading text-sm py-1 px-3 bg-[#314f6c] bg-opacity-70 w-36">
          &#160;
        </span>
        <h3 className="loading flex-1 text-lg leading-5 text-center bg-[#314f6c] bg-opacity-70 w-full py-1">
          &#160;
        </h3>
        <div className="w-full flex flex-col items-center space-y-1">
          <p className="loading text-sm text-center bg-[#314f6c] bg-opacity-70 w-full h-4">
            &#160;
          </p>
          <p className="loading text-sm text-center bg-[#314f6c] bg-opacity-70 w-3/4  h-4">
            &#160;
          </p>
        </div>
      </div>
    </li>
  );
};

export default SkeletonBlog;
